import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCloudStatus } from "@/hooks/queries/use-cloud";
import { gcpWizardPath } from "./wizard-state";

/** Step 1: where the wizard begins (linked from Connections). */
export function StartStep() {
  const { data } = useCloudStatus();
  const available = data?.oneClick.gcp ?? true;
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Connect Google Cloud</h2>
      <p className="text-sm text-muted-foreground">
        CompBox sets up a Google Cloud project for your apps: you sign in with Google, choose a project and billing account, review what
        it will cost, and CompBox builds it in the background. Nothing is created until you confirm the plan.
      </p>
      <p className="text-sm text-muted-foreground">
        Prefer Supabase for the database? Pick it in step 4. It is connected separately, from each project's Database settings.
      </p>
      {!available && (
        <p role="alert" className="text-sm text-destructive">
          This CompBox server isn't set up for Google sign-in yet, so Google Cloud can't be connected here.
        </p>
      )}
      <div className="flex gap-2">
        {available ? (
          <Button asChild>
            <Link to={gcpWizardPath("sign-in")}>Start</Link>
          </Button>
        ) : (
          <Button disabled>Start</Button>
        )}
        <Button asChild variant="outline">
          <Link to="/connections">Back to Connections</Link>
        </Button>
      </div>
    </div>
  );
}
